export default __webpack_public_path__ + "static/media/DropImage.29816ff3.svg";